export default __webpack_public_path__ + "static/media/640_private03-jp-mobile.1c8b9a58.png";